module.exports = __webpack_public_path__ + "img/magnifying-glass-location.92a275b3.svg";